import { useEffect, useState } from 'react';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { validEmail } from 'Utils/validFields';
import { StyledEmailInput } from './styles';
import { EmailInputProps } from './types';

let timeout = 0;
const TIME = 800;

const EmailInput = ({
  id = 'email',
  value: valueDefault,
  hasError: hasErrorDefault,
  errorMsg: erroMsgDefault,
  onChange,
  disabled,
  ...rest
}: EmailInputProps): JSX.Element => {
  const [errorMsg, setErrorMsg] = useState(erroMsgDefault);
  const [hasError, setHasError] = useState(hasErrorDefault);
  const [emailValue, setEmailValue] = useState(valueDefault);
  const { t } = useTranslation(locizeNS.AUTH);

  useEffect(() => {
    setErrorMsg(erroMsgDefault);
  }, [erroMsgDefault]);

  useEffect(() => {
    setHasError(hasErrorDefault);
  }, [hasErrorDefault]);

  useEffect(() => {
    setEmailValue(valueDefault);
  }, [valueDefault]);

  const onValid = (value: string): void => {
    const isEmailvalid = validEmail(value);
    if (isEmailvalid) {
      setErrorMsg('');
      setHasError(false);
      onChange({ id, value: { isValid: true } });
    } else {
      setErrorMsg('Email.errorMsg');
      setHasError(true);
      onChange({ id, value: { isValid: false } });
    }
  };

  const handleOnValid = (valueLowerCase: string): void => {
    clearTimeout(timeout);
    timeout = window.setTimeout(() => {
      onValid(valueLowerCase);
    }, TIME);
  };

  const handleOnChange = (val: string): void => {
    const valueLowerCase = val.toLowerCase().trim();
    setEmailValue(valueLowerCase);
    handleOnValid(valueLowerCase);
    onChange({ id, value: { value: valueLowerCase } });
  };

  return (
    <StyledEmailInput
      id="email"
      name="email"
      type="text"
      label={t('Auth.signIn.labelEmail')}
      testID="email"
      value={emailValue}
      hasBorder
      hasError={hasError}
      errorMsg={t(errorMsg)}
      onChange={handleOnChange}
      mb={8}
      disabled={disabled}
      {...rest}
    />
  );
};

export default EmailInput;
